import React from 'react';
import styled from 'styled-components';

import Button from 'shared/components/Button';

import { WorkflowCreatedModalFooterProps } from './types';

const StyledContainer = styled.div`
  margin-top: 3.333333333rem;
`;

const StyledButton = styled(Button)`
  && {
    width: 6.5rem;
    height: 3.666666667rem;
    min-width: unset;
  }
`;

const WorkflowCreatedModalFooter = ({
  onClose,
}: WorkflowCreatedModalFooterProps) => (
  <StyledContainer>
    <StyledButton label='Close' onClick={onClose} />
  </StyledContainer>
);

export default WorkflowCreatedModalFooter;
